import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b367f734"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "titleContainer"
}
const _hoisted_2 = {
  key: 1,
  class: "buttonsContainer photoRequestedMessage"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-center mt-2" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "closer" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_description_binder = _resolveComponent("description-binder")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", {
    class: "opModal",
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close'))),
    onTouchmove: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent","stop"]))
  }, [
    _createElementVNode("div", {
      class: "pinchTextContainer",
      ref: "pinchTextContainer",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showText = !_ctx.showText), ["stop"]))
    }, [
      (_ctx.item.title && _ctx.item.title.values && _ctx.item.title.values[_ctx.$store.state.selectedLanguage] || 
                _ctx.item.description && _ctx.item.description.values && _ctx.item.description.values[_ctx.$store.state.selectedLanguage])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["textContainer", { show: _ctx.showText }]),
            ref: "textContainer"
          }, [
            (_ctx.item.title && _ctx.item.title.values && _ctx.item.title.values[_ctx.$store.state.selectedLanguage])
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.item.title.values[_ctx.$store.state.selectedLanguage]), 1))
              : _createCommentVNode("", true),
            (_ctx.item.description && _ctx.item.description.values && _ctx.item.description.values[_ctx.$store.state.selectedLanguage])
              ? (_openBlock(), _createBlock(_component_description_binder, {
                  key: 1,
                  class: "descriptionContainer",
                  "html-text": _ctx.item.description.values[_ctx.$store.state.selectedLanguage]
                }, null, 8, ["html-text"]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_ctx.requested)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Per avere la foto in alta risoluzione clicca qui",
                      text: "Per avere la foto in alta risoluzione clicca qui"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.makePhotoPrintRequest && _ctx.makePhotoPrintRequest(...args)), ["stop"]))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Richiedi la foto!",
                        text: "Richiedi la foto!"
                      })
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!_ctx.requested.gestitaOn)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Hai richiesto la foto, recati in reception per ritirarla",
                            text: "Hai richiesto la foto, recati in reception per ritirarla"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-danger",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteRequest && _ctx.deleteRequest(...args)), ["stop"]))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Annulla richiesta",
                              text: "Annulla richiesta"
                            })
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Hai ritirato la foto!",
                          text: "Hai ritirato la foto!"
                        })
                      ]))
                ]))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-link",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_icon_close)
      ])
    ]),
    _createElementVNode("img", {
      src: _ctx.item.attachment.publicUrl,
      ref: "pinch",
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showText = !_ctx.showText), ["stop"]))
    }, null, 8, _hoisted_9)
  ], 32))
}